/* WebComponentAccordion component */
/* eslint-disable @typescript-eslint/no-unsafe-declaration-merging -- disabled to allow to inherit from AbstractComponent */
import { Component, Element, Event, EventEmitter, h, Listen } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import AccordionTemplate from './cwc-accordion.template';
import { AbstractComponent } from '@cewe-designsystem/abstract';

export type ToggledItemPayload = {
  item: HTMLElement;
  opened: boolean;
};

@Component({
  tag: 'cwc-accordion',
  shadow: false,
})
export class AccordionComponent {
  /**
   * element
   */
  @Element() element: HTMLElement;

  /**
   * Event thrown on accordion item toggle.
   *
   * @docs
   * @event on:accordion:toggle
   */
  @Event({
    bubbles: true,
    eventName: 'on:accordion:toggle',
    composed: true,
  })
  toggleItem: EventEmitter<ToggledItemPayload>;

  /**
   * Called every time the component is connected to the DOM.
   * When the component is first connected, this method is called before componentWillLoad.
   * It is important to note that this method can be called more than once, everytime, the element is attached or moved in the DOM.
   * This lifecycle hook follows the same semantics as the one described by the Custom Elements Spec
   */
  connectedCallback() {}

  /**
   * Called every time the component is disconnected from the DOM, i.e., it can be dispatched more than once
   * DO not confuse with a "onDestroy" kind of event.
   * This lifecycle hook follows the same semantics as the one described by the Custom Elements Spec.
   */
  disconnectedCallback() {}

  /**
   * Called once just after the component is first connected to the DOM.
   * A promise can be returned, that can be used to wait for the first render.
   */
  componentWillLoad() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams) {
      const accordionItem = document.getElementById(urlParams.get('accordion')) as HTMLDetailsElement | null;
      if (accordionItem != null) {
        accordionItem.open = true;
      }
    }
  }

  /**
   * handle clicks on component
   * @param ev
   */
  @Listen('click', { passive: true })
  onClick(ev) {
    if (ev.target?.tagName === 'DETAILS') {
      const toggledItem = ev.target as HTMLDetailsElement | null;
      if (toggledItem) {
        this.toggleItem.emit({
          item: toggledItem,
          opened: toggledItem.open,
        });
      }
    }
  }

  /**
   * Called once just after the component fully loaded and the first render() occurs.
   */
  componentDidLoad() {}

  /**
   * Called before every render().
   * A promise can be returned, that can be used to wait for the upcoming render.
   */
  componentWillRender() {}

  /**
   * Called after every render().
   */
  componentDidRender() {}

  /**
   * Called when the component is about to be updated because some Prop() or State() changed.
   * It is never called during the first render().
   * A promise can be returned, that can be used to wait for the next render.
   */
  componentWillUpdate() {}

  /**
   * Called just after the component updates. It is never called during the first render().
   */
  componentDidUpdate() {}

  /**
   * render
   */
  render() {
    return <AccordionTemplate controller={this} />;
  }
}

/**
 * mixin abstract functions
 */
Object.setPrototypeOf(AccordionComponent.prototype, AbstractComponent.prototype);

export interface AccordionComponent extends AbstractComponent {}

/**
 * Event thrown if the modal is opened
 *
 * @docs
 * @event on:accordion:open
 *
 @Event({
  eventName: 'on:accordion:open'
  }) onAccordionOpen: EventEmitter;
 */
